import React, { useContext } from "react";
import StateContext from "./../contexts/StateContext";
import { Route, Redirect } from "react-router-dom";

function PrivateRoute({ children, ...rest }) {
  const appState = useContext(StateContext);
  let content = children;
  if (appState.loggedIn === false) content = <Redirect to="/" />;
  return <Route {...rest}>{content}</Route>;
}
export default PrivateRoute;
